module.exports = __webpack_public_path__ + "img/activate-card.9cfa5429.svg";